
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { 
  AlertDialog, 
  AlertDialogAction, 
  AlertDialogCancel, 
  AlertDialogContent, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogHeader, 
  AlertDialogTitle 
} from '@/components/ui/alert-dialog';

interface TeamDeleteDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  teamName: string;
  confirmText: string;
  onConfirmTextChange: (text: string) => void;
  onConfirmDelete: () => void;
  isDeleting: boolean;
}

export const TeamDeleteDialog = ({
  isOpen,
  onOpenChange,
  teamName,
  confirmText,
  onConfirmTextChange,
  onConfirmDelete,
  isDeleting
}: TeamDeleteDialogProps) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Team</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete the team "{teamName}" 
            and all associated data including players and statistics.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="py-4">
          <Label htmlFor="confirm-name">
            Type the team name "{teamName}" to confirm deletion:
          </Label>
          <Input
            id="confirm-name"
            value={confirmText}
            onChange={(e) => onConfirmTextChange(e.target.value)}
            placeholder={teamName}
            className="mt-2"
            autoComplete="off"
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirmDelete}
            disabled={confirmText !== teamName || isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isDeleting ? 'Deleting...' : 'Delete Team'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
